<template>
    <v-flex xs12 mb-4 pt-4 id="social">
        <v-toolbar text>
            <v-toolbar-title>Ссылки в соц.сети</v-toolbar-title>
        </v-toolbar>
        <v-layout flex wrap>
            <v-flex xs5>
                <v-subheader class="pa-0">Facebook</v-subheader>
                <v-text-field
                    v-model="social.facebook"
                    single-line
                    text
                    solo/>
            </v-flex>
            <v-spacer/>
            <v-flex xs5>
                <v-subheader class="pa-0">Instagram</v-subheader>
                <v-text-field
                    v-model="social.instagram"
                    single-line
                    text
                    solo/>
            </v-flex>
            <v-flex xs5>
                <v-subheader class="pa-0">Telegram</v-subheader>
                <v-text-field
                    v-model="social.telegram"
                    single-line
                    text
                    solo/>
            </v-flex>
            <v-spacer/>
            <v-flex xs5>
                <v-subheader class="pa-0">Twitter</v-subheader>
                <v-text-field
                    v-model="social.twitter"
                    single-line
                    text
                    solo/>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    export default {
        name: 'social',
        props: {
            social: {
                type: Object,
                default: () => ({
                    facebook: '',
                    instagram: '',
                    telegram: '',
                    twitter: ''
                })
            }
        }
    }
</script>
